import { render, staticRenderFns } from "./selectPeople.vue?vue&type=template&id=5a4a6b2e&scoped=true&"
import script from "./selectPeople.vue?vue&type=script&lang=js&"
export * from "./selectPeople.vue?vue&type=script&lang=js&"
import style0 from "./selectPeople.vue?vue&type=style&index=0&id=5a4a6b2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4a6b2e",
  null
  
)

export default component.exports